import React from 'react';
import { Link } from 'react-router-dom';
import smille from '~/assets/default/smille.svg';
import pointer from '~/assets/default/pointer-new.svg';
import scale from '~/assets/default/scale-new.svg';
import { Score } from './styles';

const ScoreCard: React.FC = () => {
  return (
    <Score rotate={0} className="zoom bg-white p-3 mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h2 className="h3 fw-semibold">Score</h2>{' '}
        <Link className="h6 fw-normal" to="/">
          Ver completo
        </Link>
      </div>
      <hr />
      <div className="text-center mb-3">
        <img src={smille} alt="Sorriso" className="emogi" />
      </div>
      <div className="text-center position-relative">
        <img src={scale} alt="escala" className="scale" />
        <div className="divPointer">
          <img src={pointer} alt="Ponteiro" className="pointer" />
        </div>
      </div>
      <p className="h6 fw-normal text-center mb-0 mt-3">
        O score médio dos seus clientes é ótimo!
      </p>
    </Score>
  );
};

export default ScoreCard;
